// extracted by mini-css-extract-plugin
export var active = "translate-button-module--active--f1c6c";
export var safariTranslateIcon = "translate-button-module--safariTranslateIcon--17d50";
export var translateButton = "translate-button-module--translateButton--618de";
export var translateInstructions = "translate-button-module--translateInstructions--f3dfd";
export var translateInstructionsBody = "translate-button-module--translateInstructionsBody--25350";
export var translateInstructionsCloseButton = "translate-button-module--translateInstructionsCloseButton--f7a42";
export var translateInstructionsTitle = "translate-button-module--translateInstructionsTitle--ccfb8";